<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="card card-modern">
          <div class="card-header">
            <h2 class="card-title">Zaglavlje ponude</h2>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div
                  class="form-group row"
                  :class="{ 'has-danger': $v.mainForm.ordinalNumber.$anyError }"
                >
                  <label class="control-label mb-0">
                    Redni broj dokumenta
                  </label>
                  <input
                    type="number"
                    placeholder="Redni broj"
                    class="form-control form-control-modern"
                    v-model.number="mainForm.ordinalNumber"
                  />
                  <form-error
                    :model="$v.mainForm.ordinalNumber"
                    :dirty="$v.mainForm.$dirty"
                    :label="'Redni broj dokumenta'"
                  />
                </div>
                <div
                  class="form-group row"
                  :class="{ 'has-danger': $v.mainForm.title.$anyError }"
                >
                  <label class="control-label mb-0"> Naziv ponude </label>
                  <input
                    type="text"
                    placeholder="Naziv"
                    class="form-control form-control-modern"
                    v-model="mainForm.title"
                  />
                  <form-error
                    :model="$v.mainForm.title"
                    :dirty="$v.mainForm.$dirty"
                    :label="translations.forms.labels.title"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group"
                  :class="{ 'has-danger': $v.mainForm.customer.$anyError }"
                >
                  <label class="control-label">Komitent</label>
                  <input
                    type="text"
                    placeholder="Komitent"
                    class="form-control form-control-modern"
                    v-model="mainForm.customer"
                  />
                  <form-error
                    :model="$v.mainForm.customer"
                    :dirty="$v.mainForm.$dirty"
                    label="Komitent"
                  />
                </div>

                <div class="form-group">
                  <label class="control-label">Komercijalist</label>
                  <div class="select-padding">
                    <treeselect
                      :options="commercialists"
                      v-model="mainForm.commercialistId"
                    />
                  </div>
                  <form-error
                    :model="$v.mainForm.commercialistId"
                    :dirty="$v.mainForm.$dirty"
                    label="Komercijalist"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div
                  class="form-group"
                  :class="{ 'has-danger': $v.mainForm.documentCreationDate.$anyError }"
                >
                  <label class="control-label">Datum kreiranja ponude</label>
                  <div>
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                      <datepicker
                        placeholder="Datum kreiranja ponude"
                        v-model="mainForm.documentCreationDate"
                        input-class="form-control form-control-modern bg-body w-100"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                      <form-error
                        :model="$v.mainForm.documentCreationDate"
                        :dirty="$v.mainForm.$dirty"
                        :label="'Datum kreiranja ponude'"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="form-group"
                  :class="{ 'has-danger': $v.mainForm.documentExpirationDate.$anyError }"
                >
                  <label class="control-label">Datum isteka ponude</label>
                  <div class="">
                    <div class="input-group">
                      <span class="input-group-text">
                        <i class="fas fa-calendar-alt"></i>
                      </span>
                      <datepicker
                        placeholder="Datum isteka ponude"
                        v-model="mainForm.documentExpirationDate"
                        input-class="form-control form-control-modern bg-body w-100"
                        :monday-first="true"
                        :full-month-name="true"
                        :language="bs"
                        :format="customFormatter"
                        :disabled-dates="disabledDates"
                      ></datepicker>
                      <form-error
                        :model="$v.mainForm.documentExpirationDate"
                        :dirty="$v.mainForm.$dirty"
                        :label="'Datum isteka ponude'"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label mb-0"> Prefix </label>
                  <input
                    type="text"
                    placeholder="Prefix"
                    class="form-control form-control-modern"
                    v-model="mainForm.prefix"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label mb-0"> Suffix </label>
                  <input
                    type="text"
                    placeholder="Suffix"
                    class="form-control form-control-modern"
                    v-model="mainForm.suffix"
                  />
                </div>
              </div>

              <div class="col-md-6 mt-2">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <label class="control-label mb-0"> Broj dokumenta </label>
                      <input
                        type="text"
                        placeholder="Broj dokumenta"
                        class="form-control form-control-modern"
                        readonly
                        :value="documentNumber"
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="control-label mb-0"> Djelatnost </label>
                      <treeselect
                        :options="interestsAreas"
                        v-model="mainForm.interestAreaId"
                      />
                    </div>
                    <form-error
                      :model="$v.mainForm.interestAreaId"
                      :dirty="$v.mainForm.$dirty"
                      :label="'Djelatnost'"
                    />
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mt-3">
                      <label class="control-label mb-0">
                        Prikaži izvještaj sa informacijama o kompaniji
                      </label>
                      <div class="d-inline p-2 pt-4">
                        <input
                          type="checkbox"
                          v-model="mainForm.displayCompanyInformation"
                          id="visible-on-web"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="action-buttons" style="margin-top: 2rem">
                <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
                  <router-link
                    exact
                    :to="{ name: 'AdvancedOffers' }"
                    class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
                  >
                    Otkaži
                  </router-link>
                  <button
                    type="submit"
                    class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                    @click="submitForm"
                  >
                    <i class="bx bx-save text-4 me-2"></i>{{ translations.save }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form @submit.prevent.stop="submitForm">
      <div class="row mt-4">
        <div class="col">
          <div class="card card-modern card-modern-table-over-header">
            <div class="card-header">
              <div class="row align-items-center mb-5">
                <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                  <a
                    href="#add-article"
                    data-bs-toggle="modal"
                    data-bs-target="#add-article"
                    class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                  >
                    + Dodaj stavku
                  </a>
                  <button
                    class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                    type="button"
                    @click.prevent.stop="showConfirmationModal"
                  >
                    - Ukloni stavku
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body table-offer-responsive">
              <table
                v-if="mainForm.documentItems.length"
                class="table table-offer table-ecommerce-simple table-borderless table-striped mb-0"
                style="min-width: 640px"
              >
                <thead>
                  <tr>
                    <th width="30">
                      <input
                        type="checkbox"
                        class="select-all checkbox-style-1 p-relative top-2"
                        v-model="selectAll"
                      />
                    </th>
                    <th>RBR</th>
                    <th>Slika</th>
                    <th>Šifra</th>
                    <th>Naziv</th>
                    <th>Količina</th>
                    <th>VPC</th>
                    <th>Rabat</th>
                    <th>Vrijednost</th>
                    <th>Porez</th>
                    <th>Iznos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in mainForm.documentItems"
                    :key="item.tempId"
                    class="hover-row"
                  >
                    <td width="30">
                      <input
                        type="checkbox"
                        class="checkbox-style-1 p-relative top-2"
                        :value="item.tempId"
                        v-model="selected"
                      />
                    </td>
                    <td @click.prevent.stop="editArticle(item)">{{ item.ordinalNumber }}</td>
                    <td @click.prevent.stop="editArticle(item)">
                      <div>
                        <img
                          :src="`${item.imageUrl}`"
                          v-if="item.imageUrl"
                          class="product-img-thumb"
                        />
                        <img
                          v-else-if="item.articleId != null"
                          class="product-img-thumb"
                          :src="`${baseUrl}${item.articleImageThumbnailUrl || item.articleImageUrl}`"
                        />
                        <img
                          v-else
                          class="product-img-thumb"
                          :src="'img/products/product-8.jpg'"
                        />
                      </div>
                    </td>
                    <td @click.prevent.stop="editArticle(item)">
                      <strong>{{ item.code }}</strong>
                    </td>
                    <td @click.prevent.stop="editArticle(item)">
                      <strong>{{ item.title }}</strong>
                    </td>
                    <td @click.prevent.stop="editArticle(item)">
                      {{ item.quantity }} {{ measurementUnits.find(({ id }) => id === item.unitOfMeasureId).title }}
                    </td>
                    <td @click.prevent.stop="editArticle(item)">{{ item.vpc | money2 }}</td>
                    <td @click.prevent.stop="editArticle(item)">{{ item.discount1 }} %</td>
                    <td @click.prevent.stop="editArticle(item)">{{ (item.amount * item.quantity) | money2 }}</td>
                    <td @click.prevent.stop="editArticle(item)">{{ item.taxAmount | money2 }}</td>
                    <td @click.prevent.stop="editArticle(item)">{{ item.totalAmount | money2 }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-else>
                <div class="alert alert-info" role="alert">
                  {{ translations.noRecords }}
                </div>
              </div>
              <hr class="solid mt-5 opacity-4" />
              <div
                class="datatable-footer"
                v-if="mainForm.documentItems.length > 4"
              >
                <div class="row align-items-center justify-content-between mt-3">
                  <div class="col-md-auto order-1 mb-3 mb-lg-0">
                    <div class="d-flex align-items-stretch">
                      <a
                        href="#add-article"
                        data-bs-toggle="modal"
                        data-bs-target="#add-article"
                        class="btn btn-primary btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim me-1"
                      >+ Dodaj stavku</a>
                      <button
                        class="btn btn-warning btn-md font-weight-semibold btn-py-2 px-4 modal-with-zoom-anim"
                        type="button"
                        @click.prevent.stop="showConfirmationModal"
                      >
                        - Ukloni stavku
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- Add article modal -->
    <modal id="add-article" cssClass="modal-xl modal-lg modal-md">
      <header slot="header">
        <h2 class="card-title">Dodavanje artikla</h2>
      </header>
      <section slot="body">
        <div class="card-body">
          <div class="form-group row">
            <label class="col-lg-1 control-label text-lg-end pt-2">
              Pretraga
            </label>
            <div class="col-lg-11">
              <div class="header-center">
                <div class="header-search">
                  <div class="header-search-wrapper" ref="searchWrapper">
                    <input
                      type="search"
                      class="form-control"
                      placeholder="Unesite minimalno 3 karaktera"
                      v-model="searchInput"
                      @input="handleSearch"
                      @focus="handleFocus"
                      @blur="handleBlur()"
                    />
                    <ul
                      class="article-list bg-body"
                      v-if="showSearchResults"
                      @mousedown="onSearchResultsMouseDown"
                    >
                      <li
                        v-for="article in articles"
                        :key="article.id"
                        @click="
                          articleId = article.id;
                          selectArticle(article);
                          onArticleSelect('new');
                        "
                      >
                        <div class="article-wrapper">
                          <img
                            v-if="article.highlightedImageUrl"
                            :src="`${baseUrl}${article.highlightedImageThumbnailUrl || article.highlightedImageUrl}`"
                            class="article-image"
                          />
                          <img
                            v-else
                            class="article-image"
                            :src="'img/products/product-8.jpg'"
                          />
                          <div class="article-description">
                            <div class="article-title">{{ article.title }}</div>
                            <div class="article-code">{{ article.code }}</div>
                            <div class="article-price">{{ article.price | money2 }}</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <button class="btn" type="button">
                      <i class="icon-magnifier"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-4 col-12">
              <div class="form-group row">
                <label class="col-lg-3 control-label text-lg-end pt-2" for="code">Šifra</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="code"
                    v-model="article.code"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.article.title.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="article-title">Artikal</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="article-title"
                    v-model="article.title"
                  />
                  <form-error
                    :model="$v.article.title"
                    :dirty="$v.article.$dirty"
                    :label="'Artikal'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.article.unitOfMeasureId.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="measure-unit">JMJ</label>
                <div class="col-lg-9">
                  <select
                    class="form-control form-control-modern"
                    v-model="article.unitOfMeasureId"
                  >
                    <option :value="null">Izaberi jedinicu mjere</option>
                    <option
                      :value="unit.id"
                      :key="unit.id"
                      v-for="unit in measurementUnits"
                    >
                      {{ unit.description }}
                    </option>
                  </select>
                  <form-error
                    :model="$v.article.unitOfMeasureId"
                    :dirty="$v.article.$dirty"
                    :label="'JMJ'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.article.quantity.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="article-quantity">Količina</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="article-quantity"
                    v-model.number="article.quantity"
                    @input="onNewQuantityChange"
                    @blur="checkIsNull('article.quantity')"
                  />
                  <form-error
                    :model="$v.article.quantity"
                    :dirty="$v.article.$dirty"
                    :label="'Količina'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.article.vpc.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="vpc">VPC</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="vpc"
                    v-model.number="article.vpc"
                    @input="onNewVPCChange"
                    @blur="checkIsNull('article.vpc')"
                  />
                  <form-error
                    :model="$v.article.vpc"
                    :dirty="$v.article.$dirty"
                    :label="'VPC'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.article.discount1.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="">Rabat %</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    id="article-discount1"
                    class="form-control form-control-modern"
                    v-model.number="article.discount1"
                    @input="onNewDiscountChange"
                    @blur="checkIsNull('article.discount1')"
                  />
                  <form-error
                    :model="$v.article.discount1"
                    :dirty="$v.article.$dirty"
                    :label="'Rabat %'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.article.amount.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2">VPC - Rabat</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    id="article-amount"
                    class="form-control form-control-modern"
                    v-model.number="article.amount"
                    @input="onNewAmountChange"
                    @blur="checkIsNull('article.amount')"
                  />
                  <form-error
                    :model="$v.article.amount"
                    :dirty="$v.article.$dirty"
                    :label="'VPC - Rabat'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.article.taxAmount.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="">Porez 17%</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    :value="(article.taxAmount || 0).toFixed(2)"
                    readonly
                  />
                  <form-error
                    :model="$v.article.taxAmount"
                    :dirty="$v.article.$dirty"
                    :label="'Porez 17%'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.article.totalAmount.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="total-amount">Iznos</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="total-amount"
                    :value="(article.totalAmount || 0).toFixed(2)"
                    readonly
                  />
                  <form-error
                    :model="$v.article.totalAmount"
                    :dirty="$v.article.$dirty"
                    :label="'Iznos'"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="form-group row">
                <label class="col-lg-1 control-label text-lg-end pt-2" for="description">Opis</label>
                <div class="col-lg-11">
                  <editor
                    name="html-editor"
                    :init="{ ...appSettings.tinyMceConfig }"
                    v-model="article.description"
                    id="description"
                  ></editor>
                </div>
              </div>

              <div class="form-group row align-items-center mb-3">
                <label class="col-lg-1 control-label text-lg-end mb-0">Slika</label>
                <div class="col-lg-11">
                  <input
                    type="file"
                    class="form-control form-control-modern"
                    ref="photoAdd"
                    @change="handlePhotoAddUpload"
                    accept="image/*"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-default modal-dismiss mx-2"
              aria-label="Close"
              @click="closeModal"
            >
              Odustani
            </button>
            <button
              class="btn btn-primary modal-confirm"
              @click="addArticleToOffer"
            >
              Dodaj artikal
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <!-- Edit article modal -->
    <modal
      id="edit-article"
      cssClass="modal-xl modal-lg modal-md"
      v-if="selectedArticle"
      @close="closeEditModal"
    >
      <header slot="header">
        <h2 class="card-title">Ažuriranje artikla</h2>
      </header>
      <section slot="body">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 col-12">
              <div class="form-group row">
                <label class="col-lg-3 control-label text-lg-end pt-2" for="code">Šifra</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="code"
                    v-model="selectedArticle.code"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.selectedArticle.title.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="article-title">Artikal</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="article-title"
                    v-model="selectedArticle.title"
                  />
                  <form-error
                    :model="$v.selectedArticle.title"
                    :dirty="$v.selectedArticle.$dirty"
                    :label="'Artikal'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.selectedArticle.unitOfMeasureId.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="measure-unit">JMJ</label>
                <div class="col-lg-9">
                  <select
                    class="form-control form-control-modern"
                    v-model="selectedArticle.unitOfMeasureId"
                  >
                    <option :value="null">Izaberi jedinicu mjere</option>
                    <option
                      :value="unit.id"
                      :key="unit.id"
                      v-for="unit in measurementUnits"
                    >
                      {{ unit.description }}
                    </option>
                  </select>
                  <form-error
                    :model="$v.selectedArticle.unitOfMeasureId"
                    :dirty="$v.selectedArticle.$dirty"
                    :label="'JMJ'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.selectedArticle.quantity.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="article-quantity">Količina</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="article-quantity"
                    v-model.number="selectedArticle.quantity"
                    @input="onEditQuantityChange"
                    @blur="checkIsNull('selectedArticle.quantity')"
                  />
                  <form-error
                    :model="$v.selectedArticle.quantity"
                    :dirty="$v.selectedArticle.$dirty"
                    :label="'Količina'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.selectedArticle.vpc.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="vpc">VPC</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="vpc"
                    v-model.number="selectedArticle.vpc"
                    @input="onEditVPCChange"
                    @blur="checkIsNull('selectedArticle.vpc')"
                  />
                  <form-error
                    :model="$v.selectedArticle.vpc"
                    :dirty="$v.selectedArticle.$dirty"
                    :label="'VPC'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.selectedArticle.discount1.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="">Rabat %</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="edit-discount"
                    v-model.number="selectedArticle.discount1"
                    @input="onEditDiscountChange"
                    @blur="checkIsNull('selectedArticle.discount1')"
                  />
                  <form-error
                    :model="$v.selectedArticle.discount1"
                    :dirty="$v.selectedArticle.$dirty"
                    :label="'Rabat %'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.selectedArticle.amount.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="">VPC - Rabat</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="edit-amount"
                    v-model.number="selectedArticle.amount"
                    @input="onEditAmountChange"
                    @blur="checkIsNull('selectedArticle.amount')"
                  />
                  <form-error
                    :model="$v.selectedArticle.amount"
                    :dirty="$v.selectedArticle.$dirty"
                    :label="'VPC - Rabat'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.selectedArticle.taxAmount.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="">Porez 17%</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    :value="selectedArticle.taxAmount.toFixed(2)"
                    id=""
                    readonly
                  />
                  <form-error
                    :model="$v.selectedArticle.taxAmount"
                    :dirty="$v.selectedArticle.$dirty"
                    :label="'Porez 17%'"
                  />
                </div>
              </div>

              <div
                class="form-group row"
                :class="{ 'has-danger': $v.selectedArticle.totalAmount.$anyError }"
              >
                <label class="col-lg-3 control-label text-lg-end pt-2" for="total-amount">Iznos</label>
                <div class="col-lg-9">
                  <input
                    type="text"
                    class="form-control form-control-modern"
                    id="total-amount"
                    :value="(selectedArticle.totalAmount || 0).toFixed(2)"
                    readonly
                  />
                  <form-error
                    :model="$v.selectedArticle.totalAmount"
                    :dirty="$v.selectedArticle.$dirty"
                    :label="'Iznos'"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-8 col-12">
              <div class="form-group row">
                <label class="col-lg-1 control-label text-lg-end pt-2" for="description">Opis</label>
                <div class="col-lg-11">
                  <editor
                    name="html-editor"
                    :init="{ ...appSettings.tinyMceConfig }"
                    v-model="selectedArticle.description"
                    id="description-edit"
                  ></editor>
                </div>
              </div>

              <div class="form-group row align-items-center mb-3">
                <label class="col-lg-1 control-label text-lg-end mb-0">Slika</label>
                <div class="col-lg-11">
                  <input
                    type="file"
                    class="form-control form-control-modern"
                    ref="photo"
                    @change="handlePhotoUpload"
                    accept="image/*"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              class="btn btn-primary modal-confirm"
              @click="onEditArticleClose"
            >
              Spremi
            </button>
          </div>
        </div>
      </footer>
    </modal>

    <!-- Confirm delete items modal -->
    <modal id="confirm-delete">
      <h5 slot="header">
        <strong>Ukloni odabrane artikle</strong>
      </h5>
      <div slot="body">
        Jeste li sigurni da želite ukloniti odabrane artikle?
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="removeItemsFromOffer"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Leave page confirmation modal -->
    <modal id="leave-page-modal">
      <h5 slot="header">
        <strong>Nesačuvane promjene</strong>
      </h5>
      <div slot="body">
        Jeste li sigurni da želite napustiti stranicu? Spremite ponudu prije napuštanja.
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-md-12 text-end">
            <button
              type="button"
              class="btn btn-primary px-4 mx-2"
              @click.prevent.stop="confirmLeave"
              data-bs-dismiss="modal"
            >
              {{ translations.yes }}
            </button>
            <button
              type="button"
              class="btn btn-default px-4"
              data-bs-dismiss="modal"
            >
              {{ translations.no }}
            </button>
          </div>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import bs from 'vuejs-datepicker/dist/locale/translations/bs';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import validations from './validation-schema/add';
import addArticleValidations from './validation-schema/add-article';
import FormError from '../shared/form-errors/FormError.vue';
import editor from '@tinymce/tinymce-vue';
import helpers from '@/services/helpers';

import { format } from 'date-fns';
import { debounce } from 'lodash';
import { translations, pager } from '@/mixins';
import Modal from '@/components/shared/modal/Modal.vue';

import config from '@/config';
import api from '@/services/api';

const LEAVE_PAGE_MESSAGE =
  'Jeste li sigurni da želite napustiti stranicu? Spremite ponudu prije napuštanja';

export default {
  name: 'AddAdvancedOffer',
  mixins: [translations, pager],
  validations: {
    mainForm: validations,
    article: {
      ...addArticleValidations,
    },
    selectedArticle: {
      ...addArticleValidations,
    },
  },
  components: {
    Datepicker,
    Treeselect,
    editor,
    Modal,
    FormError,
  },
  data() {
    const documentExpirationDate = new Date();
    documentExpirationDate.setDate(documentExpirationDate.getDate() + 14);
    return {
      copiedSelectedArticle: null,
      proceed: true,
      initialFormSnapshot: null,
      isLeavingSafely: false,
      leavePageMessage: LEAVE_PAGE_MESSAGE,
      pendingNavigation: null,
      selectedArticle: {
        tempId: null,
        id: null,
        highlightedImageUrl: '',
        imageUrl: '',
        unitOfMeasureId: null,
        taxId: null,
        title: '',
        quantity: 0,
        description: '',
        fc: 0,
        nc: 0,
        vpc: 0,
        mpc: 0,
        discount1: 0,
        totalAmount: 0,
        taxAmount: 0,
        code: '',
        amount: 0,
        totalAmountWithoutVat: 0,
        ordinalNumber: 0,
      },
      selected: [],
      searchInput: '',
      articleImageUrl: '',
      posterUrl: '',
      showSearchResults: false,
      searchBlurTimer: null,
      searchResultsMouseDown: false,
      articleId: null,
      article: {
        tempId: null,
        id: null,
        highlightedImageUrl: '',
        imageUrl: '',
        unitOfMeasureId: null,
        taxId: null,
        title: '',
        quantity: 0,
        description: '',
        fc: 0,
        nc: 0,
        vpc: 0,
        mpc: 0,
        discount1: 0,
        totalAmount: 0,
        taxAmount: 0,
        code: '',
        amount: 0,
        totalAmountWithoutVat: 0,
        ordinalNumber: 0,
      },
      mainForm: {
        ordinalNumber: 1,
        documentTypeId: 1,
        documentCreationDate: new Date(),
        documentExpirationDate: documentExpirationDate,
        description: '',
        title: '',
        deliveryDate: new Date(),
        paymentDate: new Date(),
        paymentType: 1,
        suffix: '',
        prefix: '',
        customer: '',
        documentItems: [],
        commercialistId: null,
        displayCompanyInformation: false,
        interestAreaId: null,
      },
    };
  },
  computed: {
    selectAll: {
      get: function () {
        return this.selected.length === this.mainForm.documentItems.length;
      },
      set: function (value) {
        const selected = [];
        if (value) {
          this.mainForm.documentItems.forEach(function ({ tempId }) {
            selected.push(tempId);
          });
        }
        this.selected = selected;
      },
    },
    measurementUnits() {
      return this.$store.getters.getMeasurementUnits;
    },
    documentNumber() {
      return `${this.mainForm.prefix}${this.mainForm.ordinalNumber}${this.mainForm.suffix}`;
    },
    baseUrl() {
      return config.baseUrl;
    },
    appSettings() {
      return config.appSettings;
    },
    comitents() {
      return this.$store.getters.getCompanies.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    commercialists() {
      return this.$store.getters.getCommercialists.map(({ id, name }) => ({
        id,
        label: name,
      }));
    },
    articles() {
      let articles = this.$store.getters.getArticles;
      articles.forEach((item) => {
        if (item.price && item.price < item.vpc) {
          item.quantity = item.quantity || 0;
          item.discount = item.discount || 100 * (1 - item.price / item.vpc);
          item.amount = item.price;
        }
      });
      return articles;
    },
    interestsAreas() {
      return this.$store.getters.getInterestsAreas.map(({ id, title }) => ({
        id,
        label: title,
      }));
    },
    bs() {
      return bs;
    },
    disabledDates() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return { to: date };
    },
  },
  methods: {
    onMounted() {
      return Promise.all([
        this.$store.dispatch('getCompanies'),
        this.$store.dispatch('getMeasurementUnits', {
          sortBy: 'title',
          isSortAscending: true,
          retrieveAll: true,
        }),
        this.$store.dispatch('getInterestsAreas', {
          ...this.searchConfig,
          retrieveAll: true,
        }),
        this.getCommercialists(),
        api.getNextOrdinalNumber().then(({ data }) => {
          this.mainForm.ordinalNumber = data.data;
        }),
      ]).finally(() => {
        this.captureInitialState();
      });
    },
    normalizeDate(value) {
      if (!value) return null;
      return helpers.formatDateForApi(value);
    },
    serializeDocumentItem(item = {}) {
      return {
        tempId: item.tempId || null,
        articleId: item.articleId || null,
        unitOfMeasureId: item.unitOfMeasureId || null,
        taxId: item.taxId || null,
        ordinalNumber: item.ordinalNumber || 0,
        title: item.title || '',
        quantity: item.quantity || 0,
        description: item.description || '',
        imageUrl: item.imageUrl || '',
        imageFileName: item.image?.fileName || null,
        fc: item.fc || 0,
        nc: item.nc || 0,
        vpc: item.vpc || 0,
        mpc: item.mpc || 0,
        discount1: item.discount1 || 0,
        totalAmount: item.totalAmount || 0,
        taxAmount: item.taxAmount || 0,
        code: item.code || '',
        amount: item.amount || 0,
        totalAmountWithoutVat: item.totalAmountWithoutVat || 0,
      };
    },
    serializeMainForm() {
      const form = this.mainForm || {};
      return JSON.stringify({
        ordinalNumber: form.ordinalNumber || 0,
        documentTypeId: form.documentTypeId || null,
        documentCreationDate: this.normalizeDate(form.documentCreationDate),
        documentExpirationDate: this.normalizeDate(form.documentExpirationDate),
        description: form.description || '',
        title: form.title || '',
        deliveryDate: this.normalizeDate(form.deliveryDate),
        paymentDate: this.normalizeDate(form.paymentDate),
        paymentType: form.paymentType || null,
        suffix: form.suffix || '',
        prefix: form.prefix || '',
        customer: form.customer || '',
        commercialistId: form.commercialistId || null,
        displayCompanyInformation: Boolean(form.displayCompanyInformation),
        interestAreaId: form.interestAreaId || null,
        documentItems: (form.documentItems || []).map((item) =>
          this.serializeDocumentItem(item)
        ),
      });
    },
    captureInitialState() {
      this.initialFormSnapshot = this.serializeMainForm();
      this.isLeavingSafely = false;
    },
    hasUnsavedChanges() {
      if (!this.initialFormSnapshot) return false;
      return this.serializeMainForm() !== this.initialFormSnapshot;
    },
    shouldWarnBeforeLeaving() {
      return !this.isLeavingSafely && this.hasUnsavedChanges();
    },
    handleBeforeUnload(event) {
      if (!this.shouldWarnBeforeLeaving()) return;
      event.preventDefault();
      event.returnValue = this.leavePageMessage;
      return this.leavePageMessage;
    },
    confirmLeave() {
      if (this.pendingNavigation) {
        this.isLeavingSafely = true;
        this.pendingNavigation();
        this.pendingNavigation = null;
      }
    },
    generateGUID() {
      return crypto.randomUUID();
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const img = new Image();
      img.src = URL.createObjectURL(file);
      reader.onload = (e) => {
        this.articleImageUrl = e.target.result;
      };
      img.onload = () => {
        this.posterUrl = img.src;
      };
    },
    handlePhotoAddUpload() {
      const file = this.$refs.photoAdd.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const img = new Image();
      img.src = URL.createObjectURL(file);
      reader.onload = (e) => {
        this.articleImageUrl = e.target.result;
      };
      img.onload = () => {
        this.posterUrl = img.src;
      };
    },
    resetArticle() {
      this.article = {
        id: null,
        highlightedImageUrl: '',
        unitOfMeasureId: null,
        taxId: null,
        title: '',
        quantity: 0,
        description: '',
        fc: 0,
        nc: 0,
        vpc: 0,
        mpc: 0,
        discount1: 0,
        totalAmount: 0,
        taxAmount: 0,
        code: '',
        amount: 0,
        totalAmountWithoutVat: 0,
        ordinalNumber: 0,
      };
    },
    onEditArticleClose() {
      this.$v.selectedArticle.$touch();
      if (this.$v.selectedArticle.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        return;
      }

      if (this.posterUrl != '') {
        this.selectedArticle.imageUrl = this.posterUrl;
        if (this.$refs.photo.files[0]) {
          const file = this.$refs.photo.files[0];
          this.selectedArticle.image = {
            file: this.articleImageUrl.split(',')[1],
            fileName: file.name,
          };
        }
        this.$refs.photo.value = '';
        this.posterUrl = '';
        this.articleImageUrl = '';
      }

      this.articleId = null;
      $('#edit-article').modal('hide');
    },
    customFormatter(date) {
      return format(date, 'dd.MM.yyyy.');
    },
    addArticleToOffer() {
      this.$v.article.$touch();
      if (this.$v.article.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        return;
      }

      this.$store.commit('SET_ARTICLES', []);
      this.article.ordinalNumber = this.mainForm.documentItems.length + 1;

      let {
        tempId = this.generateGUID(),
        id,
        highlightedImageUrl,
        highlightedImageThumbnailUrl,
        unitOfMeasureId,
        taxId,
        title,
        quantity,
        description,
        fc,
        nc,
        vpc,
        mpc,
        imageUrl,
        image,
        discount1,
        totalAmount,
        taxAmount,
        code,
        amount,
        totalAmountWithoutVat = totalAmount - taxAmount,
        ordinalNumber,
      } = this.article;

      if (this.posterUrl != '') {
        imageUrl = this.posterUrl;
        if (this.$refs.photoAdd.files[0]) {
          const file = this.$refs.photoAdd.files[0];
          image = {
            file: this.articleImageUrl.split(',')[1],
            fileName: file.name,
          };
        }
        this.$refs.photoAdd.value = '';
        this.posterUrl = '';
        this.articleImageUrl = '';
      }

      this.mainForm.documentItems.push({
        tempId,
        articleId: id,
        articleImageUrl: highlightedImageUrl,
        articleImageThumbnailUrl: highlightedImageThumbnailUrl,
        unitOfMeasureId,
        taxId,
        ordinalNumber,
        title,
        quantity,
        description,
        imageUrl,
        image,
        fc,
        nc,
        vpc,
        mpc,
        discount1,
        totalAmount,
        taxAmount,
        code,
        amount,
        totalAmountWithoutVat,
      });

      $('#add-article').modal('hide');

      this.articleId = null;
      this.resetArticle();

      this.mainForm.documentItems.forEach((item) => {
        item.amount = parseFloat(item.amount.toFixed(2));
      });

      this.$v.article.$reset();
    },
    submitForm() {
      this.$v.mainForm.$touch();

      if (this.$v.mainForm.$invalid) {
        this.$toast.error(this?.translations?.forms?.notValid);
        this.$nextTick(() => {
          let elem = document.querySelector('.has-danger');
          elem?.scrollIntoView(true);
        });
        return;
      }

      const {
        documentTypeId,
        ordinalNumber,
        documentCreationDate,
        documentExpirationDate,
        description,
        title,
        deliveryDate,
        paymentDate,
        paymentType,
        suffix,
        prefix,
        customer,
        documentItems,
        commercialistId,
        displayCompanyInformation,
        interestAreaId,
      } = this.mainForm;

      const payload = {
        documentTypeId,
        ordinalNumber,
        documentCreationDate: this.normalizeDate(documentCreationDate),
        documentExpirationDate: this.normalizeDate(documentExpirationDate),
        description,
        title,
        deliveryDate: this.normalizeDate(deliveryDate),
        paymentDate: this.normalizeDate(paymentDate),
        paymentType,
        suffix,
        prefix,
        customer,
        totalAmount: documentItems.reduce(
          (prev, current) => prev + current.totalAmount,
          0
        ),
        documentItems,
        commercialistId,
        displayCompanyInformation,
        interestAreaId,
      };

      api
        .createAdvancedOffer(payload)
        .then((response) => {
          this.$toast.info(response.data.info);
          if (response.status == 200) {
            this.isLeavingSafely = true;
            this.$router.push({
              name: 'EditAdvancedOffer',
              params: { id: response.data.data },
            });
          }
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    getCommercialists() {
      return this.$store.dispatch('getCommercialists');
    },
    removeCommercialist() {
      this.mainForm.commercialistId = null;
    },
    editArticle(item) {
      this.selectedArticle = item;
      this.copiedSelectedArticle = { ...item };
      setTimeout(() => {
        $('#edit-article').modal('show');
      }, 100);
    },
    closeEditModal() {
      this.selectedArticle.quantity = this.copiedSelectedArticle.quantity;
      this.selectedArticle.fc = this.copiedSelectedArticle.fc;
      this.selectedArticle.nc = this.copiedSelectedArticle.nc;
      this.selectedArticle.code = this.copiedSelectedArticle.code;
      this.selectedArticle.title = this.copiedSelectedArticle.title;
      this.selectedArticle.vpc = this.copiedSelectedArticle.vpc;
      this.selectedArticle.amount = this.copiedSelectedArticle.amount;
      this.selectedArticle.discount1 = this.copiedSelectedArticle.discount1;
      this.selectedArticle.taxAmount = this.copiedSelectedArticle.taxAmount;
      this.selectedArticle.totalAmount = this.copiedSelectedArticle.totalAmount;
      this.selectedArticle.description = this.copiedSelectedArticle.description;
      this.selectedArticle.totalAmountWithoutVat = this.copiedSelectedArticle.totalAmountWithoutVat;
      this.selectedArticle.ordinalNumber = this.copiedSelectedArticle.ordinalNumber;
      this.articleId = null;
      $('#edit-article').modal('hide');
    },
    closeModal() {
      this.articleId = null;
      $('#add-article').modal('hide');
    },
    removeItemsFromOffer() {
      this.mainForm.documentItems = this.mainForm.documentItems.filter(
        (item) => !this.selected.includes(item.tempId)
      );
    },
    showConfirmationModal() {
      if (this.selected.length) $('#confirm-delete').modal('show');
    },
    onSearchResultsMouseDown() {
      this.searchResultsMouseDown = true;
    },
    onDocumentMouseUp() {
      if (this.searchResultsMouseDown) {
        this.searchResultsMouseDown = false;
      }
    },
    onDocumentMouseDown(event) {
      if (!this.showSearchResults) return;
      const wrapper = this.$refs.searchWrapper;
      if (wrapper && wrapper.contains(event.target)) return;
      this.showSearchResults = false;
    },
    handleFocus() {
      if (this.searchBlurTimer) {
        clearTimeout(this.searchBlurTimer);
        this.searchBlurTimer = null;
      }
      if (this.searchInput.trim().length < 3) {
        this.showSearchResults = false;
        return;
      }
      this.showSearchResults = true;
      this.handleSearch();
    },
    handleBlur() {
      if (this.searchBlurTimer) {
        clearTimeout(this.searchBlurTimer);
      }
      const ignoreBlur = this.searchResultsMouseDown;
      this.searchBlurTimer = setTimeout(() => {
        if (ignoreBlur) {
          this.searchBlurTimer = null;
          return;
        }
        this.showSearchResults = false;
        this.searchResultsMouseDown = false;
        this.searchBlurTimer = null;
      }, 250);
    },
    handleSearch: debounce(function search() {
      const quickSearch = this.searchInput.trim();
      if (quickSearch.length < 3) {
        this.showSearchResults = false;
        return;
      }
      this.showSearchResults = true;
      this.$store.dispatch('getArticles', {
        sortBy: 'title',
        isSortAscending: false,
        page: 1,
        retrieveAll: true,
        quickSearch,
        brandIds: [],
        categoryIds: [],
        attributeValuesIds: [],
        tagIds: [],
      });
    }, 300),
    onNewQuantityChange() {
      this.changeTotalAmountOfNewArticle();
    },
    onNewVPCChange() {
      let { vpc, discount1 } = this.article;
      vpc = vpc || 0;
      discount1 = discount1 || 0;
      this.article.amount = parseFloat(
        ((vpc || 0) - (vpc || 0) * ((discount1 || 0) / 100)).toFixed(2),
        10
      );
      this.changeTotalAmountOfNewArticle();
    },
    onNewDiscountChange() {
      let { vpc, discount1 } = this.article;
      vpc = vpc || 0;
      discount1 = discount1 || 0;
      this.article.amount = parseFloat(
        ((vpc || 0) - (vpc || 0) * ((discount1 || 0) / 100)).toFixed(2),
        10
      );
      this.changeTotalAmountOfNewArticle();
    },
    onNewAmountChange() {
      if (this.article.amount > this.article.vpc)
        this.article.amount = this.article.vpc;
      this.article.discount1 = (
        100 * (1 - this.article.amount / this.article.vpc)
      ).toFixed(2);
      this.changeTotalAmountOfNewArticle();
    },
    onEditQuantityChange() {
      this.changeTotalAmountOfEditArticle();
    },
    onEditVPCChange() {
      let { vpc, discount1 } = this.selectedArticle;
      vpc = vpc || 0;
      discount1 = discount1 || 0;
      this.selectedArticle.amount = parseFloat(
        (vpc - vpc * (discount1 / 100)).toFixed(2),
        10
      );
      this.changeTotalAmountOfEditArticle();
    },
    onEditDiscountChange() {
      let { vpc, discount1 } = this.selectedArticle;
      vpc = vpc || 0;
      discount1 = discount1 || 0;
      this.selectedArticle.amount = parseFloat(
        (vpc - vpc * (discount1 / 100)).toFixed(2),
        10
      );
      this.changeTotalAmountOfEditArticle();
    },
    onEditAmountChange() {
      if (this.selectedArticle.amount > this.selectedArticle.vpc)
        this.selectedArticle.amount = this.selectedArticle.vpc;
      this.selectedArticle.discount1 = (
        100 * (1 - this.selectedArticle.amount / this.selectedArticle.vpc)
      ).toFixed(2);
      this.changeTotalAmountOfEditArticle();
    },
    checkIsNull(property) {
      if (property === 'article.vpc' && !this.article.vpc) {
        this.article.vpc = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.quantity' && !this.article.quantity) {
        this.article.quantity = 1;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.discount1' && !this.article.discount1) {
        this.article.discount1 = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'article.amount' && !this.article.amount) {
        this.article.amount = 0;
        this.changeTotalAmountOfNewArticle();
      } else if (property === 'selectedArticle.vpc' && !this.selectedArticle.vpc) {
        this.selectedArticle.vpc = 0;
        this.changeTotalAmountOfEditArticle();
      } else if (property === 'selectedArticle.quantity' && !this.selectedArticle.quantity) {
        this.selectedArticle.quantity = 1;
        this.changeTotalAmountOfEditArticle();
      } else if (property === 'selectedArticle.discount1' && !this.selectedArticle.discount1) {
        this.selectedArticle.discount1 = 0;
        this.changeTotalAmountOfEditArticle();
      } else if (property === 'selectedArticle.amount' && !this.selectedArticle.amount) {
        this.selectedArticle.amount = 0;
        this.changeTotalAmountOfEditArticle();
      }
    },
    onArticleSelect(type) {
      if (type === 'new') {
        if (!this.article.vpc) this.article.vpc = 0;
        if (!this.article.quantity) this.article.quantity = 1;
        if (!this.article.discount1) this.article.discount1 = 0;
        this.article.amount = parseFloat(
          (
            this.article.vpc -
            this.article.vpc * (this.article.discount1 / 100)
          ).toFixed(2),
          10
        );
        this.changeTotalAmountOfNewArticle();
      }
    },
    selectArticle(article) {
      this.article = {
        id: article.id || null,
        highlightedImageUrl: article.highlightedImageUrl || '',
        highlightedImageThumbnailUrl: article.highlightedImageThumbnailUrl || '',
        unitOfMeasureId: article.unitOfMeasureId,
        taxId: article.taxId || null,
        title: article.title || '',
        quantity: article.quantity || 0,
        description: article.description || '',
        fc: article.fc || 0,
        nc: article.nc || 0,
        vpc: article.vpc || 0,
        mpc: article.mpc || 0,
        discount1: article.discount1 || 0,
        totalAmount: article.totalAmount || 0,
        taxAmount: article.taxAmount || 0,
        code: article.code || '',
        amount: article.amount || 0,
        totalAmountWithoutVat: (article.totalAmount || 0) - (article.taxAmount || 0),
        ordinalNumber: article.ordinalNumber || 0,
      };
      this.showSearchResults = false;
    },
    changeTotalAmountOfNewArticle() {
      let { quantity } = this.article;
      this.article.totalAmount = parseFloat(
        (this.article.amount * 1.17 * (quantity || 0)).toFixed(2),
        10
      );
      this.article.taxAmount = this.article.amount * 0.17 * (quantity || 0);
      this.article.totalAmountWithoutVat =
        this.article.totalAmount - this.article.taxAmount;
    },
    changeTotalAmountOfEditArticle() {
      let { quantity } = this.selectedArticle;
      this.selectedArticle.totalAmount = parseFloat(
        (this.selectedArticle.amount * 1.17 * (quantity || 0)).toFixed(2),
        10
      );
      this.selectedArticle.taxAmount =
        this.selectedArticle.amount * 0.17 * (quantity || 0);
      this.selectedArticle.totalAmountWithoutVat =
        this.selectedArticle.totalAmount - this.selectedArticle.taxAmount;
    },
    resetForm() {
      this.$v.mainForm.$reset();
      this.mainForm.documentCreationDate = new Date();
      this.mainForm.documentExpirationDate.setDate(
        this.mainForm.documentCreationDate.getDate() + 14
      );
      this.copiedSelectedArticle = null;
      this.proceed = true;
      this.selectedArticle = null;
      this.selected = [];
      this.searchInput = '';
      this.showSearchResults = true;
      this.articleId = null;
      this.mainForm.documentTypeId = 1;
      this.mainForm.ordinalNumber = 1;
      this.mainForm.description = '';
      this.mainForm.title = '';
      this.mainForm.deliveryDate = new Date();
      this.mainForm.paymentDate = new Date();
      this.mainForm.paymentType = 1;
      this.mainForm.suffix = '';
      this.mainForm.prefix = '';
      this.mainForm.customer = '';
      this.mainForm.documentItems = [];
      this.mainForm.commercialistId = null;
      this.mainForm.interestAreaId = null;
      this.mainForm.displayCompanyInformation = false;
    },
  },
  mounted() {
    this.onMounted();
    document.addEventListener('mousedown', this.onDocumentMouseDown);
    document.addEventListener('mouseup', this.onDocumentMouseUp);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown);
    document.removeEventListener('mouseup', this.onDocumentMouseUp);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.onDocumentMouseDown);
    document.removeEventListener('mouseup', this.onDocumentMouseUp);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (!this.shouldWarnBeforeLeaving()) {
      next();
      return;
    }
    this.pendingNavigation = next;
    this.$nextTick(() => {
      $('#leave-page-modal').modal('show');
    });
    next(false);
  },
  watch: {
    documentItems() {
      this.selected = [];
    },
  },
};
</script>

<style lang="scss">
.hover-row:hover {
  background-color: #f5f5f5;
  transition: background 0.2s;
}

.product-img-thumb {
  width: 70px;
  height: auto;
}

.table-offer td {
  padding-bottom: 0;
  padding-top: 0;
}

.select-padding {
  padding: 0;
}

.form-group + .form-group {
  border-top: none;
}

.form-control.form-control-modern
  + .select2-container--bootstrap
  .select2-selection--single,
.form-control.form-control-modern
  + .select2-container--bootstrap
  .select2-selection--multiple {
  border-color: #e7e7e7;
  line-height: 2.8;
  height: 45px;
  padding: 3px 24px 6px 17px;
}

.select2-container--bootstrap.select2-container--focus .select2-selection,
.select2-container--bootstrap.select2-container--open .select2-selection {
  border-color: #33bbff !important;
  box-shadow: 0 1px 1px rgb(0 0 0 / 8%) inset, 0 0 8px rgb(0 136 204 / 30%) !important;
}

.select2-container--bootstrap {
  width: 100% !important;
}

.modal-md-2.modal-dialog {
  min-width: 620px;

  .card-body {
    padding: 0 0.5em;
    box-shadow: none;
  }
}

.modal-lg-2.modal-dialog {
  min-width: 1250px;

  .card-body {
    padding: 0 0.5em;
    box-shadow: none;
  }
}

.vdp-datepicker {
  width: calc(100% - 40px);

  input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.vue-treeselect {
  min-height: 44px;
}

.vue-treeselect__control {
  min-height: 44px;
}

.vue-treeselect__value-container {
  min-height: 44px;
}

.header-center {
  position: relative;
}

.article-list {
  position: absolute;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  list-style: none;
  padding: 0;
  z-index: 1020;
  left: 0;
  top: 40px;
  width: 100%;
  background: #fff;
  max-height: 450px;
  overflow-y: auto;

  li {
    display: block;
    border-top: 1px solid #ced4da;
    padding: 5px;
    cursor: pointer;
    overflow: hidden;
    opacity: 0.75;

    &:first-child {
      border-top: none;
    }

    &:hover {
      opacity: 1;
      .article-title {
        color: #259ddf;
        text-decoration: underline;
      }
    }
  }
}

.article-wrapper {
  display: flex;
  flex-basis: 50%;
}

.article-description {
  display: flex;
  flex-direction: column;
  height: 80px;
  color: #777;
}

.article-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin-right: 5px;
}

.product-image {
  display: block;
  width: 70px;
  height: 70px;
}

.product-image-container {
  margin-right: 5px;
}

.article-title,
.article-code,
.article-price {
  width: 100%;
  font-size: 16px;
  flex-basis: 50%;
}
</style>
